<template>
    <div class="no-message">
        <img class="" src="/static/img/empty-filter-result.png" />
        <!--<div>{{ $t("message.noMessage") }}</div>-->
        <div>
            <h2 v-if="Title">{{ Title }}</h2>
        </div>
        <div v-if="Desc">{{ Desc }}</div>
    </div>
</template>

<script>
export default {
    name: "NoMessage",
    props: ["Title", "Desc"],
};
</script>

<style scoped lang="scss">
.no-message {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    min-height: 300px;

    img {
        width: 200px;
    }

    div {
        margin-bottom: 5px;
        margin-top: 10px;
        color: #22272d;
        font-weight: 600;

        font-size: 18px;
        line-height: 23px;
        text-align: center;
    }
}
</style>
